import {createContext, useReducer} from 'react';
import {convertMMtoPxWithScaling} from "../services/helpers";
import FontsMapper from "../services/FontsMapper";

const SNAP_ON_CM = 0.5;
const SNAP_OFF_CM = 0.1;

const letterspacing = [
    {value: 0.7, label: '0.7'},
    {value: 1, label: '1'},
    {value: 2, label: '2'},
];

const initData = {
    //selected values
    selectedFont: '',
    selectedFontObject : {fonts_conf : [{}] },
    selectedFontSize: '',
    selectedLetterSpacing: '',
    selectedColor: '',
    selectedMounting: '',
    selectedMaterial: '',
    selectedType: '',
    allowNumbersAndSymbols: false,
    fontType: '',
    fontUrl: '',
    selectedFontSizeObject : { slug: '' , id: 0},
    selectedColorObject : { id: 0 },
    //raw data
    mountingList: [],
    materialList: [],
    typeList: [],
    fontsColorsList: [],
    fontsSizesList: [],
    fontsLetterSpacingList: [],
    fontsData: [],
    //data for font selector
    fontSizeOptions: [],
    fontsLetterSpacingOptions: [],
    colorOptions: [],
    typeOptions: [],
    //default
    errorMsg : false,
    additionalWorkingSizeMargin : 300,
    showGrid: true, // domyślnie siatka widoczna
    gridSpacingCm: 1, // fixed 3cm grid spacing
    snapToGrid: true,
    dragSnapSpacingCm: SNAP_ON_CM,
}

const fontsMapper = new FontsMapper();

export const ConfigContext = createContext(null);
export const ConfigDispatch = createContext(null);
export function ConfigProvider({children}) {
    const [config, dispatch] = useReducer(
        ConfigReducer,
        initData
    );
    return (
        <ConfigContext.Provider value={config}>
            <ConfigDispatch.Provider value={dispatch}>
                {children}
            </ConfigDispatch.Provider>
        </ConfigContext.Provider>
    )
}

function ConfigReducer(config, action) {
    switch (action.type) {
        case 'set' :
            return action.payload;
        case 'changeFontFamily':
            let selectedFont = config.fontsData.find((font) => font.fontFamily === action.payload);
            const result = {
                ...config,
                //raw data
                fontsColorsList: selectedFont.colors,
                fontsSizesList: selectedFont.fonts_conf,
                fontsLetterSpacingList: letterspacing,
                mountingList: selectedFont.mounting,
                materialList: selectedFont.material,
                typeList: selectedFont.type,
                //selected values
                selectedFont: action.payload,
                selectedFontSize: selectedFont.fonts_conf[0].font_size.name,
                allowNumbersAndSymbols : selectedFont.fonts_conf[0].symbols,
                fontUrl: selectedFont.fonts_conf[0].font,
                selectedLetterSpacing: letterspacing[0].label,
                selectedColor: selectedFont.colors[1].name,
                selectedMounting: selectedFont.mounting[0].name,
                selectedMaterial: selectedFont.material[0].name,
                selectedType: selectedFont.type[1].name,
                //selected objects
                selectedFontObject: selectedFont,
                selectedFontSizeObject: selectedFont.fonts_conf[0].font_size,
                selectedLetterSpacingObject: letterspacing[0],
                selectedColorObject: selectedFont.colors[1],
                selectedMountingObject: selectedFont.mounting[0],
                selectedMaterialObject: selectedFont.material[0],
                selectedTypeObject: selectedFont.type[1],
                //data for font selector
                fontsLetterSpacingOptions : letterspacing,
                fontSizeOptions: selectedFont.fonts_conf.map((font) => {
                    return {
                        value: font.font_size.name,
                        label: font.font_size.name
                    }
                }),
                colorOptions: selectedFont.colors.map((color) => {
                    return {
                        value: color.name,
                        label: color.name
                    }
                }),
                typeOptions: selectedFont.type.map((type) => {
                    return {
                        value: type.name,
                        label: type.name
                    }
                }),
                //allowed types
                allowedBigLetters: selectedFont.fonts_conf[0].allowed_big_letters,
                allowedSmallLetters: selectedFont.fonts_conf[0].allowed_small_letters,
                allowedSpecial : selectedFont.fonts_conf[0].allowed_special,
                allowedNumbers: selectedFont.fonts_conf[0].allowed_numbers,
                //default
                additionalWorkingSizeMargin : 300,
                showGrid: true,
                gridSpacingCm: 3,
                snapToGrid: true,
                dragSnapSpacingCm: SNAP_ON_CM,
                woocommerceProductId: selectedFont.woocommerce_product_id,
            };
            return result;
        case 'changeFontSize':
            let selectedFontSize = config.fontsSizesList.find((font) => font.font_size.name === action.payload);
            if(!selectedFontSize) {
                return config;
            }
            return {
                ...config,
                selectedFontSize: action.payload,
                fontType: selectedFontSize.selct_font_type,
                fontUrl: selectedFontSize.font,
                selectedFontSizeObject: selectedFontSize.font_size,
                allowedBigLetters : selectedFontSize.allowed_big_letters,
                allowedSmallLetters : selectedFontSize.allowed_small_letters,
                allowedSpecial : selectedFontSize.allowed_special,
                allowedNumbers: selectedFontSize.allowed_numbers,
            };
        case 'changeLetterSpacing':
            const selectedLetterSpacing = config.fontsLetterSpacingList.find((font) => font.name === action.payload);
            return {
                ...config,
                selectedLetterSpacing: action.payload,
                selectedLetterSpacingObject: selectedLetterSpacing
            };
        case 'changeColor':
            const selectedColor = config.fontsColorsList.find((font) => font.name === action.payload);
            return {
                ...config,
                selectedColor : action.payload,
                selectedColorObject: selectedColor
            };
        case 'changeType':
            const selectedType = config.typeList.find((font) => font.name === action.payload);
            return {
                ...config,
                selectedType : action.payload,
                selectedTypeObject: selectedType
            };
        case 'setErrorMsg':
            return {
                ...config,
                errorMsg: action.payload
            };
        case 'toggleGridView':
            return {
                ...config,
                showGrid: action.payload
            };
        case 'toggleSnapToGrid':
            return {
                ...config,
                snapToGrid: action.payload,
                dragSnapSpacingCm: action.payload ? SNAP_ON_CM : SNAP_OFF_CM
            };
        default:
            throw Error('Unknown action: ' + action.type);
    }
}